<template>
  <div class="file-input-modal">
    <v-card flat>
      <v-card-title>
        <span>Regulamento</span>
        <v-btn
          @click="onClick"
          color="primary"
        >
          {{ button }}
        </v-btn>
      </v-card-title>
      <SdzModal
        ref="sdzModal"
        @close="close"
        :close-icon="true"
        hide-cancel-button
        hide-confirm-button
        width="550"
        title="Regulamento"
        confirmation-event="onConfirm"
      >
        <v-card-text>
          <div
            class="d-flex justify-center"
          >
            <object
              :data="`${terms}#toolbar=1&navpanes=0`"
              type="application/pdf"
              height="320"
            />
          </div>
        </v-card-text>
      </SdzModal>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'AcceptTermsModal',

    components: {
      SdzModal: () => import('@/components/sdz/SdzModal.vue')
    },

    props: {
      title: {
        type: String,
        default: () => ''
      },
      button: {
        type: String,
        default: () => ''
      },
      terms: {
        type: String,
        default: () => ''
      }
    },

    methods: {
      onClick() {
        this.$refs.sdzModal.open()
      },
      close () {
        this.$refs.sdzModal.close()
      },
    }
  }
</script>

<style lang="stylus" scoped>
.file-input-modal {
  .v-card__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-size: 14px;
    }
  }
}
</style>
